import { Button, makeStyles, TextField } from 'beam'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Row } from './Row'

const useStyles = makeStyles({
  emailInputRootOverride: {
    marginTop: 0,
  },
})

export interface EmailEntryProps {
  initialValue: string,
  onNext: (email: string) => void,
}

export function EmailEntry({ initialValue, onNext }: EmailEntryProps): ReactElement {
  const [email, setEmail] = useState(initialValue)
  const classes = useStyles()
  const { t } = useTranslation()
  const isValid = email.length > 0
  return (
    <form onSubmit={() => onNext(email)}>
      <Row>
        <TextField
          name="email"
          value={email}
          label={t('emailAddress')}
          autoComplete="email"
          onChange={event => setEmail(event.target.value)}
          classes={{ root: classes.emailInputRootOverride }}
          inputProps={{ 'data-testid': 'EmailEntry-EmailTextInput' }}
          fullWidth
        />
      </Row>
      <Row>
        <Button type="submit" disabled={!isValid} variant="contained" color="secondary" data-testid="EmailEntry-NextButton">
          {t('next')}
        </Button>
      </Row>
    </form>
  )
}
